import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { ROLE_ADMIN } from '../../constants/roles';
import isUserHaveRole from '../../utils/isUserHaveRole';
import getItems from '../../api/cars/getItems';

// components
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';

// icons
import leads from '../../brand/generated/sidebar/cars.svg';

const CarNavigation = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const [showBuTab, setShowBuTab] = useState(false);

  useEffect(() => {
    if (!id) return;
    getItems({ id })
      .then((res) => {
        const car = res?.data?.cars?.[0];
        const origin = car?.originCarId;
        const allowed = [3, 4, 5, 6];
        setShowBuTab(allowed.includes(origin));
      })
      .catch(() => {
        setShowBuTab(false);
      });
  }, [id]);

  const items = useMemo(() => {
    const baseItems = [
      { text: 'Основные данные', navigate: id ? `/cars/car/${id}/main-data` : '/cars/create' },
      { text: 'Доп оборудование', navigate: id ? `/cars/car/${id}/equipments` : '/cars/create' },
      { text: 'Документы', navigate: id ? `/cars/car/${id}/documents` : '/cars/documents' },
    ];

    if (id && showBuTab) {
      baseItems.push({ text: 'Дополнительная информация', navigate: `/cars/car/${id}/bu-info` });
    }

    if (isUserHaveRole(ROLE_ADMIN)) {
      baseItems.push({ text: 'Сделки', navigate: id ? `/cars/car/${id}/deals` : '/cars/deals' });
    }

    return baseItems;
  }, [id, showBuTab]);

  return (
    <>
      <Header title={id ? `ID ${id}` : 'Новый автомобиль'} icon={leads} />
      <Breadcrumbs
        navigate={'/cars'}
        link={'Автомобили'}
        currentPage={id ? `ID ${id}` : 'Новый автомобиль'}
      />
      {!pathname.endsWith('/create') && <Navbar items={items} />}
      <Outlet />
    </>
  );
};

export default CarNavigation;
